import { FormFieldValue } from '../types';
import { TextFormFieldValidator } from './TextFormFieldValidator';

export class EmailFormFieldValidator extends TextFormFieldValidator {
  protected getErrorTags(value: FormFieldValue): string[] | undefined {
    const tags: string[] = [];
    if (!this.requiredCheck(value) || !this.lengthCheck(value)) {
      tags.push('fieldAttributes');
    } else {
      tags.push('emailFormat');
    }
    return tags;
  }

  private emailCheck(value: FormFieldValue) {
    const regexp = /^[a-zA-Z0-9.%&'+=_~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return regexp.test(value as string);
  }

  protected isValid(value: FormFieldValue) {
    return this.isEmpty(value)
      ? this.requiredCheck(value)
      : this.requiredCheck(value) && this.lengthCheck(value) && this.emailCheck(value);
  }
}
